import { Component, OnInit, TemplateRef, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Globals } from '../objects/Globals';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { LoginModalComponent } from '../login-modal/login-modal.component';

import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TokenManager } from '../Globals';
import { ForgotLoginComponent } from '../forgot-login/forgot-login.component';
import { AppSession } from '../objects/Session';
import { EnvService } from '../env.service';
import { ModalControlComponent } from '../modal-control/modal-control.component';
import { WorkspaceService } from '../services/workspace.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  submitted: boolean = false;
  modalRef: BsModalRef;
  isEmptyUsername: boolean = false;
  isInvalid: boolean = false;
  portalTitle:string;
  portalBackground:string;
  isLoginPage: boolean = false;
  showLoginTerms: boolean = false;
  urlRouter: Subscription;
  private primaryColour:string;

  @ViewChild('username') public username:ElementRef;

  constructor(private route:ActivatedRoute, 
    private loginService:LoginService, 
    public globals: Globals, 
    private router:Router, 
    private modalService: BsModalService,
    private tokenManager:TokenManager,
    private env: EnvService,
    private workspaceService: WorkspaceService) { 
      this.portalTitle = this.env.portalTitle;
      this.portalBackground = this.env.loginBackdrop;
      this.primaryColour = this.env.primaryColor;
      this.showLoginTerms = this.env.showLoginTerms;

      this.urlRouter = router.events.subscribe((val) => {
          if (router.url.indexOf("/login") > -1) {
              this.isLoginPage = true;
          }
          else {
              this.isLoginPage = false
          }
      });

    }

  openModal(template: TemplateRef<any>, username: string, event: any) {
    this.isInvalid = false;
    this.isEmptyUsername = false;
    if (event.key == "Enter"){
      this.launchModal(template, username);
    }
  }

  launchModal(template: TemplateRef<any>, username: string) {
    document.querySelectorAll('.body-content').item(0).classList.add('mb-login');
    document.querySelectorAll('.navbar').item(0).classList.add('mb-login');
    if (username) {
      this.isEmptyUsername = false;
      var config = {
        keyboard: false,
        ignoreBackdropClick: true,
        class: 'modal-dialog-centered modal-login',
        focus:false,
        initialState : {
          username: username.trim()
        }
      };
      this.modalService.onHide.subscribe((reason: string) => {
        this.username.nativeElement.focus();
      })
      this.modalRef = this.modalService.show(LoginModalComponent, config);
      this.modalRef.content.invalid.subscribe((value) => {
        this.isInvalid = value;
        });
    }else {
      this.isEmptyUsername = true;
    }
  }

  forgotLoginDetails(){
    var config = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-forgot-login',
      focus:false
    };
    document.querySelectorAll('.body-content').item(0).classList.add('mb-login');
    document.querySelectorAll('.navbar').item(0).classList.add('mb-login');
    this.modalRef = this.modalService.show(ForgotLoginComponent, config);
  }

  onChangeUsername() {
    this.isInvalid = false;
    this.isEmptyUsername = false;
  }

  ngOnInit() {
    var sessionCookie = JSON.parse(this.tokenManager.retrieve("BRNSessionKey"));
    var self = this;
    if(sessionCookie){
      this.loginService.getSession(sessionCookie).subscribe(result => 
        {
          if(result){
            var checkSessionObject = JSON.parse(result);
            if(checkSessionObject.SessionObject)
            {
              var sessionObject:AppSession = checkSessionObject.SessionObject;
              self.globals.Session = sessionObject;
              self.globals.CardItems = [];
              var currentRoute = JSON.parse(this.tokenManager.retrieve("BRNCurrentRoute"));
              if(currentRoute){
                this.router.navigateByUrl(currentRoute);
              }else{
                this.router.navigate(['/', 'home']);
              }
              this.loginService.setSession(self.globals.Session);
            }
          }
        }, error => {
          this.tokenManager.store("BRNSessionKey", null);
         });
    }else{
      this.notificationPopup();
      //this.router.navigate(['/', 'login']);
    }
  }

  notificationPopup(){
    if (this.isLoginPage && !this.globals.Session) { // && session is there
      this.workspaceService.getNotificationPrompt().subscribe(result => {
        if (result){
         var notificationPrompt = JSON.parse(result);
        //var notificationPrompt = {
        //  Title: "<i>Notification to the users</i>",
        //  Message: "Sime Darby Berhad eProcurement Portal will undergo a system upgrade. This upgrade is scheduled to start on 18th July 2020 from 7pm and is expected to complete on 18th July 2020 at 9pm (KL Time). Please log out of the system by the designated time to avoid any lost work. We apologize for any inconvenience this may cause."}        

        var config = {
          keyboard: false,
          ignoreBackdropClick: true,
          class: 'modal-dialog-centered modal-notification',
          focus:false,
          initialState: {
            type: "notification",
            title: notificationPrompt.Title,
            message: notificationPrompt.Message
          }
        };

        document.querySelectorAll('.body-content').item(0).classList.add('mb-login');
        document.querySelectorAll('.navbar').item(0).classList.add('mb-login');
        this.modalRef = this.modalService.show(ModalControlComponent, config);
       }
      })
     }
  }

  ngOnDestroy(){
    if (this.urlRouter){
      this.urlRouter.unsubscribe();
    }
  }
}